import { useState, useRef } from "react";
import { useGeolocated } from "react-geolocated";

const reverseGeocode = async (lat, lon) => {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
    );
    const data = await res.json();
    return {
      country: data.address?.country || "",
      city:
        data.address?.city || data.address?.town || data.address?.village || "",
      region: data.address?.state || data.address?.region || "",
      longitude: data.lon || data.longitude || data.longitude || "",
      latitude: data.lat || data.latitude || data.latitude || "",
    };
  } catch (err) {
    return { country: "", city: "", region: "", longitude: "", latitude: "" };
  }
};

export default function useLocation() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const geoTriedRef = useRef(false);
  const { coords, getPosition } = useGeolocated({
    suppressLocationOnMount: true,
    userDecisionTimeout: 5000,
  });

  const getLocation = async () => {
    setLoading(true);
    setError(null);
    let location = {
      country: "",
      city: "",
      region: "",
      longitude: "",
      latitude: "",
    };
    // 1. Try browser native geolocation
    try {
      location = await new Promise((resolve) => {
        if (!navigator.geolocation) {
          return resolve(location);
        }
        navigator.geolocation.getCurrentPosition(
          async (pos) => {
            const { latitude, longitude } = pos.coords;
            const geo = await reverseGeocode(latitude, longitude);
            resolve(geo);
          },
          async (err) => {
            resolve(null); // Will handle fallback below
          },
          { timeout: 5000 }
        );
      });
    } catch (err) {
      location = null;
    }

    // If browser native failed, try react-geolocated
    if (!location || !location.country) {
      geoTriedRef.current = true;
      getPosition();
      let tries = 0;
      while ((!coords || !coords.latitude) && tries < 3) {
        await new Promise((r) => setTimeout(r, 200));
        tries++;
      }
      if (coords && coords.latitude) {
        location = await reverseGeocode(coords.latitude, coords.longitude);
      } else {
        location = null;
      }
    }
    setLoading(false);
    return {
      country: (location && location.country) || "",
      city: (location && location.city) || "",
      region: (location && location.region) || "",
      latitude: (location && location.latitude) || "",
      longitude: (location && location.longitude) || "",
    };
  };

  return { getLocation, loading, error };
}
